import { ThemeConfig } from 'antd';
import { createContext, useState, useCallback, useMemo } from 'react';
import { getDefaultMode } from '@/utils';
import { useUniversityContext } from '../UniversityContext';
import themes from './themes';

export type AppContextType = {
  mode: AppModules;
  theme: ThemeConfig;
  setMode: (mode: AppModules) => void;
}

export const AppContext = createContext<AppContextType>({
  mode: 'nurture',
  setMode: () => {},
  theme: undefined
});

export const AppContextProvider = ({ children }) => {

  const { university } = useUniversityContext();
  const [mode, setAppMode] = useState<AppModules>(getDefaultMode(university));

  const setMode = useCallback((mode: AppModules) => {
    setAppMode(mode);
  }, [setAppMode]);

  const theme = useMemo(() => themes[mode] ?? themes['base'], [mode]);

  return (
    <AppContext.Provider
      value={{ mode, setMode, theme }}>
      {children}
    </AppContext.Provider>
  );
};
